import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";
import { useAuth } from "../contexts/AuthContext";
import { validatePassword, PASSWORD_HINT } from "../utils/passwordRules";
import "./ForcePasswordChange.css";

// Where a user lands when an administrator reset their password and required
// them to choose their own. ProtectedRoute sends every other route here until
// it is done, so there is deliberately no way out of this screen except
// setting a password or signing out.
export default function ForcePasswordChange() {
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");

    if (!password || !confirm) {
      setError("Please fill in both fields.");
      return;
    }
    if (password !== confirm) {
      setError("The passwords do not match.");
      return;
    }
    if (!validatePassword(password)) {
      setError(PASSWORD_HINT);
      return;
    }

    setSaving(true);
    try {
      await api.post("/change-password", { Password: password });

      // The server has cleared the flag; the stored user still carries it, and
      // the guard reads the stored user. Signing in again is not necessary and
      // would be a poor welcome.
      login({ ...user, mustchangepassword: false });
      navigate("/home", { replace: true });
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.status === 400
          ? "The server rejected that password. " + PASSWORD_HINT
          : "Could not set the password. Please try again."
      );
      setSaving(false);
    }
  };

  return (
    <div className="fpc-root">
      <form className="fpc-card" onSubmit={submit}>
        <h1 className="fpc-title">Choose a new password</h1>
        <p className="fpc-lead">
          Your password was reset by an administrator. Pick one of your own to
          carry on.
        </p>

        <label className="fpc-label" htmlFor="fpc-new">
          New password
        </label>
        <input
          id="fpc-new"
          className="fpc-input"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={saving}
        />

        <label className="fpc-label" htmlFor="fpc-confirm">
          Confirm password
        </label>
        <input
          id="fpc-confirm"
          className="fpc-input"
          type="password"
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          disabled={saving}
        />

        <p className="fpc-hint">{PASSWORD_HINT}</p>

        {error && <div className="fpc-error">{error}</div>}

        <button className="fpc-submit" type="submit" disabled={saving}>
          {saving ? "Saving…" : "Set password"}
        </button>

        <button
          className="fpc-signout"
          type="button"
          onClick={() => {
            logout();
            navigate("/login", { replace: true });
          }}
        >
          Sign out
        </button>
      </form>
    </div>
  );
}
